import * as Yup from 'yup';

const schema = Yup.object().shape({
  title: Yup.string().nullable().default('').required('Informe o título'),
  body: Yup.string().nullable().default('').required('Informe a mensagem'),
  channel: Yup.string().nullable().default('all').required('Informe o canal'),
  severity: Yup.string().nullable().default('INFO').required('Informe a severidade'),
  cliente: Yup.object().nullable().default(null),
  modelo: Yup.object().nullable().default(null),
  createdAt: Yup.date().nullable().default(null),
  expiresAt: Yup.date().nullable().default(null),
});

export default schema;
